module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_1,75_spsa_desc_blanco.eb07774c.png";